import { FC } from 'react';

import { selectRatePlanVasLegalTerms } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { LegalTextWrapper } from './LegalText.styles';

export const RatePlanVasLegalText: FC = () => {
    const { cart } = useCartQuery();
    const vasLegalTerms = selectRatePlanVasLegalTerms(cart);

    if (!vasLegalTerms) {
        return null;
    }

    return <LegalTextWrapper content={vasLegalTerms} />;
};
